import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#00f2ff", // неоновый голубой
        },
        secondary: {
            main: "#ff00e0", // неоновый розовый
        },
        background: {
            default: "#0f0f0f",
            paper: "#1a1a1a",
        },
        text: {
            primary: "#ffffff",
            secondary: "#a0a0a0",
        },
    },
    typography: {
        fontFamily: "'Inter', sans-serif",
    },
});

export default theme;
